import React from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { currency, formatNumber } from 'helpers/utils';
import SoftBadge from 'components/common/SoftBadge';
import Avatar from 'components/common/Avatar';
import classNames from 'classnames';

const TableFnc = ({ data, setData, setFinancing }) => {
 const { financings } = data;
 return (
  <Table hover responsive striped size="sm">
   <thead>
    <tr>
     <th scope="col">Separacion</th>
     <th scope="col">Inicial</th>
     <th scope="col">Financiacion</th>
     <th scope="col">Intereses</th>
     <th className="text-end" scope="col">
      .........
     </th>
    </tr>
   </thead>
   <tbody>
    {!!financings &&
     financings?.map((e, i) => (
      <tr className="hover-actions-trigger align-middle" key={i}>
       <td className="text-nowrap">
        <div className="flex-1 align-items-center fs--1">
         <h6 className="mb-0 text-primary fs--1">{e.name}</h6>
         <SoftBadge pill bg="dark">
          {currency(e.minInitialPay, true, true)} min
          <FontAwesomeIcon icon="caret-up" className="ms-1" />
         </SoftBadge>
        </div>
       </td>
       <td className="text-nowrap">
        <div className="d-flex align-items-center">
         <Avatar
          size="l"
          mediaClass="fs-0"
          obj={{
           val: e.initialFee * 100,
           badge: '%',
           placeClass: 'position-absolute top-0 start-100 translate-middle fs--1'
          }}
         />
         <div className="flex-1 fs--1">
          <h5 className="mb-0 ms-3 text-primary fs--2">
           {e.maxInitials} cta max
           <FontAwesomeIcon icon="caret-up" className="ms-1" />
          </h5>
          <p className="ms-1 mb-0">${formatNumber(e.minFeeIni)} cta min</p>
         </div>
        </div>
       </td>
       <td className="text-nowrap">
        <div className="d-flex align-items-center">
         <Avatar
          size="l"
          mediaClass="fs-0"
          obj={{
           val: (1 - e.initialFee) * 100,
           badge: '%',
           placeClass: 'position-absolute top-0 start-100 translate-middle fs--1'
          }}
         />
         <div className="flex-1 fs--1">
          <h5 className="mb-0 ms-3 text-primary fs--2">
           {e.maxFinancing} cuotas
           <FontAwesomeIcon icon="caret-up" className="ms-1" />
          </h5>
          <p className="ms-1 mb-0">${formatNumber(e.minFeeFnc)} cta min</p>
         </div>
        </div>
       </td>
       <td className="text-nowrap">
        <div className="d-flex align-items-center">
         <ul className="fa-ul ms-2 ps-x1 mb-0">
          <li className="py-0">
           <h6 className="text-700 fs--2 mb-1">
            <FontAwesomeIcon
             icon={e.lateFee > 0 ? 'check' : 'ban'}
             className={classNames('fa-li', {
              'text-success': e.lateFee > 0,
              'text-secondary': e.lateFee == 0
             })}
            />
            mora
            <SoftBadge pill bg={e.lateFee > 0 ? 'success' : 'secondary'} className="ms-2">
             {e.lateFee} mes
             <FontAwesomeIcon icon={e.lateFee > 0 ? 'caret-up' : 'caret-down'} className="ms-1" />
            </SoftBadge>
           </h6>
          </li>

          <li className="py-0">
           <h6 className="text-700 fs--2 mb-1">
            <FontAwesomeIcon
             icon={e.rate > 0 ? 'check' : 'ban'}
             className={classNames('fa-li', {
              'text-success': e.rate > 0,
              'text-secondary': e.rate == 0
             })}
            />
            tasa
            <SoftBadge pill bg={e.rate > 0 ? 'success' : 'secondary'} className="ms-2">
             {e.rate * 100}%
             <FontAwesomeIcon icon={e.rate > 0 ? 'caret-up' : 'caret-down'} className="ms-1" />
            </SoftBadge>
           </h6>
          </li>

          <li className="py-0">
           <h6 className="text-700 fs--2 mb-1">
            <FontAwesomeIcon
             icon={e.amortize > 0 ? 'check' : 'ban'}
             className={classNames('fa-li', {
              'text-success': e.amortize > 0,
              'text-secondary': e.amortize < 1
             })}
            />
            amortizacion
            <SoftBadge pill bg={e.amortize > 0 ? 'success' : 'secondary'} className="ms-2">
             {e.amortize}
             <FontAwesomeIcon icon={e.amortize > 0 ? 'caret-up' : 'caret-down'} className="ms-1" />
            </SoftBadge>
           </h6>
          </li>
         </ul>
        </div>
       </td>
       <td className="w-auto">
        <div className="end-0 top-50 pe-3 translate-middle-y hover-actions">
         <Button
          variant="link"
          type="button"
          className="d-flex align-items-center fs--1 text-700 p-0"
          onClick={() => setFinancing(e)}
         >
          <FontAwesomeIcon icon="pencil-alt" />
         </Button>

         <Button
          size="sm"
          variant="link"
          type="button"
          className="d-flex align-items-center fs--1 text-700 p-0 ms-1"
          onClick={() =>
           setData(
            'financings',
            financings.filter(a => a.name !== e.name),
            {
             shouldValidate: true,
             shouldTouch: true
            }
           )
          }
         >
          <FontAwesomeIcon icon="trash-alt" />
         </Button>
        </div>
       </td>
      </tr>
     ))}
   </tbody>
  </Table>
 );
};

TableFnc.propTypes = {
 data: PropTypes.object.isRequired,
 setData: PropTypes.func.isRequired,
 setFinancing: PropTypes.func.isRequired
};

export default TableFnc;
